import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import Markdown from "markdown-to-jsx";
import WarrantyCollapsedHeader from "@/pages/checkout/components/PaymentInfo/WarrantyCollapsedHeader";
var DrawerPaymentInfo = function DrawerPaymentInfo(_ref) {
  var _checkoutOrderV2$sect;
  var checkoutOrderV2 = _ref.checkoutOrderV2,
    _ref$hideData = _ref.hideData,
    hideData = _ref$hideData === void 0 ? false : _ref$hideData,
    _ref$showOrderNumber = _ref.showOrderNumber,
    showOrderNumber = _ref$showOrderNumber === void 0 ? false : _ref$showOrderNumber,
    onClickInfoIcon = _ref.onClickInfoIcon,
    warranty_promo_code = _ref.warranty_promo_code,
    children = _ref.children;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;

  /* ── shared row classes ─────────────────────────────── */
  var row = "flex justify-between items-start mt-4 gap-1";
  var rowLabel = "text-[#484848] text-sm leading-6 font-semibold";
  var rowValue = "text-[#484848] text-base leading-6 font-bold whitespace-nowrap shrink-0";
  var rowNote = "w-full text-[#6c7a8d] text-[10px] leading-4";

  // ── V2 rendering path ──────────────────────────────────────────────────────
  var SKIP = new Set(['car_header', 'meta']);
  var TAIL = new Set(['total', 'info_card']);
  var sections = (_checkoutOrderV2$sect = checkoutOrderV2.sections) !== null && _checkoutOrderV2$sect !== void 0 ? _checkoutOrderV2$sect : [];
  var visible = sections.filter(function (s) {
    return !SKIP.has(s.type);
  });
  var ordered = [].concat(_toConsumableArray(visible.filter(function (s) {
    return !TAIL.has(s.type);
  })), _toConsumableArray(visible.filter(function (s) {
    return TAIL.has(s.type);
  })));
  var renderSection = function renderSection(section) {
    switch (section.type) {
      case 'price_row':
        {
          var _section$items, _item$note_info;
          var item = (_section$items = section.items) === null || _section$items === void 0 ? void 0 : _section$items[0];
          if (!item || item.hide) return null;
          return /*#__PURE__*/React.createElement("div", {
            className: row
          }, /*#__PURE__*/React.createElement("span", {
            className: "".concat(rowLabel, " flex items-center gap-1 flex-wrap")
          }, item.title, item.style && /*#__PURE__*/React.createElement(Markdown, {
            className: "font-medium text-xs [&>strong]:font-bold px-1 py-0.5 rounded",
            style: {
              color: item.style.text_color,
              backgroundColor: item.style.background_color
            }
          }, item.style.label), item.value_desc && /*#__PURE__*/React.createElement("p", {
            className: rowNote
          }, item.value_desc)), item.show_note && item.note_info ? /*#__PURE__*/React.createElement("div", {
            className: "flex gap-[9px] w-[150px] items-center justify-end cursor-pointer",
            onClick: function onClick() {
              return onClickInfoIcon === null || onClickInfoIcon === void 0 ? void 0 : onClickInfoIcon();
            }
          }, /*#__PURE__*/React.createElement("strong", {
            className: "text-[#6D7A8D] text-sm font-bold leading-6"
          }, (_item$note_info = item.note_info) === null || _item$note_info === void 0 ? void 0 : _item$note_info.mobile_sub_title), /*#__PURE__*/React.createElement("img", {
            className: "cursor-pointer",
            src: CDN_LINK + "/assets/images/Vector.svg",
            alt: "icon"
          })) : item.is_free ? /*#__PURE__*/React.createElement("strong", {
            className: "text-[#00b362] font-bold flex flex-col items-end gap-1 text-xl"
          }, item.formatted_value, item.formatted_old_value && /*#__PURE__*/React.createElement(Markdown, {
            className: "!text-[#6c7a8d] underline [text-underline-offset:-40%] [text-decoration-skip-ink:none] text-base leading-[18px] font-bold [&_p]:font-bold [&_*]:font-bold [&_del]:[text-decoration:none]"
          }, String(item.formatted_old_value))) : /*#__PURE__*/React.createElement("strong", {
            className: rowValue
          }, item.formatted_value));
        }
      case 'total':
        {
          var _section$items2;
          var _item = (_section$items2 = section.items) === null || _section$items2 === void 0 ? void 0 : _section$items2[0];
          if (!_item || _item.hide) return null;
          return /*#__PURE__*/React.createElement("div", {
            className: "flex justify-between flex-wrap border-t border-solid text-center pb-2 border-[#D6DFE9] pt-4 box-border border-b border-b-[3px]"
          }, /*#__PURE__*/React.createElement("span", {
            className: "text-[#484848] text-sm leading-6 font-bold"
          }, _item.title), /*#__PURE__*/React.createElement("strong", {
            className: "text-[#484848] text-xl leading-[22px] font-bold whitespace-nowrap shrink-0"
          }, _item.formatted_value));
        }
      case 'info_card':
        {
          var _section$items3;
          var _item2 = (_section$items3 = section.items) === null || _section$items3 === void 0 ? void 0 : _section$items3[0];
          if (!_item2 || _item2.hide || hideData) return null;
          return /*#__PURE__*/React.createElement("div", {
            className: "flex justify-between flex-nowrap border-t-2 border-[#d6dfe9] pt-6"
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex flex-col"
          }, /*#__PURE__*/React.createElement("span", {
            className: "text-[#484848] text-sm leading-6 font-semibold"
          }, _item2.title), _item2.value_desc2 && /*#__PURE__*/React.createElement("p", {
            className: "text-[#6D7A8D] text-xs leading-5 pe-4"
          }, _item2.value_desc2)), /*#__PURE__*/React.createElement("strong", {
            className: "text-[#00b362] text-xl leading-[22px] font-bold whitespace-nowrap shrink-0"
          }, _item2.formatted_value, _item2.value_desc && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
            className: "!text-xs font-normal"
          }, _item2.value_desc))));
        }
      case 'warranty_list':
        {
          var _section$items4, _header_warranty$styl, _header_warranty$styl2, _header_warranty$styl3, _header_warranty$styl4, _header_warranty$styl5, _header_warranty$styl6, _header_warranty$valu, _header_warranty$old_, _header_warranty$form, _header_warranty$form2, _header_warranty$is_f;
          var _item3 = (_section$items4 = section.items) === null || _section$items4 === void 0 ? void 0 : _section$items4[0];
          if (!(_item3 !== null && _item3 !== void 0 && _item3.header_warranty)) return null;
          var header_warranty = _item3.header_warranty;
          var warrantyPriceDetails = {
            title: (_header_warranty$styl = (_header_warranty$styl2 = header_warranty.style) === null || _header_warranty$styl2 === void 0 ? void 0 : _header_warranty$styl2.label) !== null && _header_warranty$styl !== void 0 ? _header_warranty$styl : "",
            text_color: (_header_warranty$styl3 = (_header_warranty$styl4 = header_warranty.style) === null || _header_warranty$styl4 === void 0 ? void 0 : _header_warranty$styl4.text_color) !== null && _header_warranty$styl3 !== void 0 ? _header_warranty$styl3 : "",
            highlight_background: (_header_warranty$styl5 = (_header_warranty$styl6 = header_warranty.style) === null || _header_warranty$styl6 === void 0 ? void 0 : _header_warranty$styl6.background_color) !== null && _header_warranty$styl5 !== void 0 ? _header_warranty$styl5 : "",
            price: {
              current: (_header_warranty$valu = header_warranty.value) !== null && _header_warranty$valu !== void 0 ? _header_warranty$valu : 0,
              original: (_header_warranty$old_ = header_warranty.old_value) !== null && _header_warranty$old_ !== void 0 ? _header_warranty$old_ : 0,
              current_formatted: (_header_warranty$form = header_warranty.formatted_value) !== null && _header_warranty$form !== void 0 ? _header_warranty$form : "",
              original_formatted: (_header_warranty$form2 = header_warranty.formatted_old_value) !== null && _header_warranty$form2 !== void 0 ? _header_warranty$form2 : ""
            },
            is_free: (_header_warranty$is_f = header_warranty.is_free) !== null && _header_warranty$is_f !== void 0 ? _header_warranty$is_f : header_warranty.value === 0
          };
          return /*#__PURE__*/React.createElement("div", {
            className: "my-2"
          }, /*#__PURE__*/React.createElement(WarrantyCollapsedHeader, {
            warrantyPriceDetails: warrantyPriceDetails,
            warranty_promo_code_enabled: warranty_promo_code
          }));
        }
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "box-border px-6 pb-8"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "block font-bold text-[#484848] text-xl leading-8 border-solid text-center pb-5 border-b border-[#D6DFE9]"
  }, tShort("drawer_payment/price_details", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-[#d6dfe9] pt-4 flex flex-col gap-0"
  }, ordered.map(function (section) {
    return /*#__PURE__*/React.createElement("div", {
      key: section.key
    }, renderSection(section));
  })), children);
};
export default DrawerPaymentInfo;